import React from 'react';
import AdditionalElementQuestionResults from './AdditionalElementQuestionResults';

import styles from '../Review.module.scss';

function AdditionalElementResults({ page, capabilityElement }) {
  const { additionalElements } = page;

  if (additionalElements.length === 0) {
    return null;
  }

  return (
    <div className={styles['additional-element-results']}>
      <h3 className={styles['additional-element-capability-name']}>
        Additional Questions: {capabilityElement.name}
      </h3>
      <div className={'survey-review-grid'}>
        {additionalElements.map((element) => (
          <AdditionalElementQuestionResults
            key={element.guid}
            page={page}
            capabilityElement={capabilityElement}
            element={element}
          />
        ))}
      </div>
    </div>
  );
}

export default AdditionalElementResults;
